module.exports = __webpack_public_path__ + "img/calendar-10.d2290a6e.svg";